module.exports = __webpack_public_path__ + "static/media/paso 3.51b36f14.svg";